import type { ReactElement } from 'react';

import { PlusPaywall } from 'app/shared-components/PlusPaywall';

export default function ManagedRepeatsPaywall(): ReactElement {
  return (
    <PlusPaywall
      title="Digital Managed Repeats automates your ordering"
      description="Manage repeat prescriptions for patients not using the app, using our award winning scheduled order technology."
      image={{ src: '/assets/images/plus-paywall/managed-repeats.webp' }}
    />
  );
}
